import React, { FC, ReactNode } from 'react'
import classNames from 'classnames'
import { StyledRadio } from '.'

type Props = {
  direction?: 'ltr' | 'rtl';
  // ^ Handles the direction of the toggle relative to text
  // ltr: Left to right (default), rtl: Right to left
  label?: string | ReactNode;
  value: string;
  className?: string;
  name: string;
  children?: ReactNode;
  isChecked?: boolean;
  isDisabled?: boolean;
  [x: string]: any;
}

const Radio: FC<Props> = ({
  direction = 'ltr',
  label,
  value,
  className,
  name,
  children,
  isChecked,
  isDisabled,
  ...props
}) => {
  return (
    <StyledRadio
      direction={direction}
      isDisabled={isDisabled}
      className={classNames('radio', className)}
    >
      <div className="radio-box">
        <input
          name={name}
          value={value}
          disabled={isDisabled}
          id={name + value}
          type="radio"
          checked={isChecked}
          {...props}
        />
      </div>
      {label && <label htmlFor={name + value}>{label}</label>}
      {children}
    </StyledRadio>
  )
}

export default Radio
